import styled from "styled-components";

export const StyledParagraph = styled.p`
    font-family: 'Poppins', monospace;
    font-size: 1rem;
`;